import { theme } from '../../theme'

const DEFAULT_COLOR = theme.colors.silver

export const addOpacity = (color: string, opacity: string): string | undefined => {
  if (!color) {
    return undefined
  }
  return `${color}${opacity}`
}

/**
 * Retourne noir ou blanc, selon ce qui est lisible sur la couleur de fond donnée.
 * Le fond est paramétrable par client, donc on choisit le contraste dynamiquement.
 * Fallback noir si la couleur est absente ou non parsable (ex: nom CSS "red").
 * @param bg couleur de fond au format hex (#rgb ou #rrggbb)
 */
export const readableTextColor = (bg?: string | null): string => {
  const { black, white } = theme.colors
  if (!bg) {
    return black
  }
  const hex = bg.replace('#', '')
  const full = hex.length === 3 ? hex.replace(/./g, c => c + c) : hex
  if (full.length !== 6) {
    return black
  }
  const r = parseInt(full.slice(0, 2), 16)
  const g = parseInt(full.slice(2, 4), 16)
  const b = parseInt(full.slice(4, 6), 16)
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    return black
  }
  // luminance perçue (pondération sRGB) ramenée sur [0,1]
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.5 ? black : white
}

/**
 * Retourne dans tous les cas une couleur (primaryColor > secondColor > DEFAULT_COLOR)
 * @param primaryColor La couleur qu'on souhaite affiché de base
 * @param secondColor La couleur secondaire si la primaryColor n'est pas renseigné
 */
export const getColor = (primaryColor: string | null, secondColor?: string | null): string => {
  if (primaryColor) {
    return primaryColor
  }

  if (secondColor) {
    return secondColor
  }

  return DEFAULT_COLOR
}
